import koalition from '../../../api/koalition'
import useFormBuilder from '../../../hooks/FormBuilderHook'
import Input from '../../forms/Input/Input'
import Validators from '../../../forms/Validators'
import { useModal } from '../../../contexts/Modal'
import { useEffect, useRef, useState } from 'react'
import { useToaster } from '../../../contexts/Toaster'
import { useCharacters } from '../../../contexts/Characters'

const NewStellarSeason = ({}) => {
    const modal = useModal()
    const toaster = useToaster()
    const characters = useCharacters()
    const formName = 'newStellarSeason'

    const createStellarSeasonRef = useRef()
    createStellarSeasonRef.current = () => {
        const formValues = form.$state.value

        const stellarSeason = {
            ...formValues,
            server: characters.$state.current.server._id
        }

        koalition.post('stellarSeasons', stellarSeason).then((response) => {
            modal.close()
            toaster.success('Stellar season created successfully')
        }).catch((error) => {
            toaster.error(error)
            console.error(error)
        })
    }

    const form = useFormBuilder({ formName, onSubmit: () => createStellarSeasonRef.current(), controls: {
        name: { validators: [Validators.required, Validators.integer, Validators.min(1)] },
    } })

    useEffect(() => {
        modal.configure({ formName, submitLabel: 'Create' })
    }, [])

    return (
        <div className="row">
            <div className="col-12 mb-3">
                <Input type="number" control={form.$state.controls.name} label="Name" />
            </div>
        </div>
    )
}

export default NewStellarSeason